import * as fuzzySearch from '@m31coding/fuzzy-search';

import { generateErrorMsg } from './toastUtils';
import {
  CountryCode,
  Option,
  PostCheckoutSurveyOptionStatus,
  PostCheckoutSurveyOption,
} from '../pages/types';

export const STATUS_OPTIONS: Option[] = [
  { value: PostCheckoutSurveyOptionStatus.ACTIVE, label: PostCheckoutSurveyOptionStatus.ACTIVE },
  { value: PostCheckoutSurveyOptionStatus.HIDDEN, label: PostCheckoutSurveyOptionStatus.HIDDEN },
];

const labelToSlug = (label: string): string =>
  label
    .toLowerCase()
    .replace(/\([^)]*\)/g, '')
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '_');

export const isValidPostCheckoutSurveyOptionLabel = (label: string): boolean =>
  Boolean(labelToSlug(label));

export const generatePostCheckoutSurveyOptionValue = (
  label: string,
  country: CountryCode
): string => {
  const suffix = country === CountryCode.CA ? '_can' : '_us';
  const slug = labelToSlug(label);
  if (!slug) {
    throw new Error('Label must contain at least one alphanumeric character');
  }
  return `${slug}${suffix}`;
};

const DUPLICATE_MATCH_MIN_QUALITY = 0.7;

export const findSimilarPostCheckoutSurveyOption = (
  label: string,
  existingOptions: PostCheckoutSurveyOption[]
): PostCheckoutSurveyOption | undefined => {
  const searcher = fuzzySearch.SearcherFactory.createDefaultSearcher<
    PostCheckoutSurveyOption,
    string
  >();
  searcher.indexEntities(
    existingOptions,
    (o) => o.id,
    (o) => [o.label]
  );
  const result = searcher.getMatches(
    new fuzzySearch.Query(label, 1, [new fuzzySearch.FuzzySearcher(DUPLICATE_MATCH_MIN_QUALITY)])
  );
  return result.matches[0]?.entity;
};

const isValueConflictError = (error: any): boolean =>
  Array.isArray(error?.response?.data?.value) && error.response.data.value.length > 0;

export const getCreatePostCheckoutSurveyOptionErrorMsg = (error: any, value: string): string => {
  if (isValueConflictError(error)) {
    return `PPS value ${value} already exists. Please reach out in bug-reporting if you believe this is an error.`;
  }
  return generateErrorMsg(error);
};
